export default __webpack_public_path__ + "static/media/ag-img.ba3b4025.webp";